
import { ICast } from "@/types/cast";
import UserProfileCard from "@/components/parts/UserProfileCard.vue";
import Vue from "vue";
import { CastApi } from "@/adapter/castApi";
import { route_home } from "@/router";
import UserImgListCard from "@/components/parts/UserImgListCard.vue";
export default Vue.extend({
  components: {
    UserProfileCard,
    UserImgListCard,
  },
  data(): {
    castData: ICast | null;
    selectedImgUrl: string;
  } {
    return {
      castData: null,
      selectedImgUrl: "",
    };
  },
  async created() {
    const cast: ICast | null = this.$store.getters["cast/getCast"];
    if (cast != null && this.$route.params.id == cast.uid) {
      // すでにstoreに情報があるため、そのまま表示する
      this.castData = cast;
      return;
    }

    // storeに別データが入っているため再取得する
    const casts = new CastApi();
    const userInfo = await casts.getUserInfo(true, this.$route.params.id);
    if (userInfo.data == null) {
      // 該当のユーザが存在しない or データを取得できない時はホーム画面にリダイレクト
      this.$router.push(route_home);
      return;
    }

    this.$store.dispatch("cast/setCastData", userInfo.data);
    this.castData = userInfo.data;
  },
});
